import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDataSourceTemplateDetailDocument,
  type GetDataSourceTemplateDetailQuery,
  type GetDataSourceTemplateDetailQueryVariables,
} from "~/features/dataSourceTemplates/gqls";
import { useTenant } from "~/features/tenant/context";

export function useDataSourceTemplateDetail(dataSourceTemplateId: string) {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  return useSuspenseQuery<GetDataSourceTemplateDetailQuery, GetDataSourceTemplateDetailQueryVariables>(
    GetDataSourceTemplateDetailDocument,
    { variables: { tenantId, dataSourceTemplateId } },
  );
}
